import request from '@/utils/request'

// 获取轮播图列表
export function getBannerList(params) {
  return request({
    url: '/admin/api/banners',
    method: 'get',
    params
  })
}

// 创建轮播图
export function createBanner(data) {
  return request({
    url: '/admin/api/banners',
    method: 'post',
    data
  })
}

// 更新轮播图
export function updateBanner(id, data) {
  return request({
    url: `/admin/api/banners/${id}`,
    method: 'put',
    data
  })
}

// 删除轮播图
export function deleteBanner(id) {
  return request({
    url: `/admin/api/banners/${id}`,
    method: 'delete'
  })
}

// 批量更新排序
export function updateBannerSort(data) {
  return request({
    url: '/admin/api/banners/sort',
    method: 'put',
    data
  })
}